import React, { useState, ChangeEvent, useEffect } from 'react';

interface TextAreaInputProps {
    value?: string;
    onValueChange?: (value: string) => void;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({ value, onValueChange }) => {
    const [inputValue, setInputValue] = useState(value || '');
    
    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    const handleInputChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = event.target.value;
        setInputValue(newValue);

        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    return <textarea value={inputValue} onChange={handleInputChange} className="form-control"></textarea>
}

export default TextAreaInput;